var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMandate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 193.032,
    height: 193.032,
    viewBox: "0 0 193.032 193.032",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#2176ff;}.c{fill:#ffc84d;}.d{fill:#4d8dff;}.e{fill:#ff4e4a;}.f{fill:#232323;}.g{fill:#2b2b2b;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-684.213 -1525.516)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M136.593,69.5c-.451.724-.9,1.436-1.38,2.146a109.956,109.956,0,0,1-15.169,17.919c-.261.258-.534.519-.806.778-.821.779-1.669,1.559-2.516,2.31-1.461,1.341-2.966,2.638-4.5,3.881-.806.683-1.639,1.354-2.46,2.009a171.551,171.551,0,0,1-29.781,19.12c-3.115,1.559-6.231,2.952-9.306,4.155-16.047,6.357-30.983,7.846-41.288,1.544a24.642,24.642,0,0,1-8.311-8.459q-.533-.884-1.066-1.763c-3.292-5.509-6.437-11.043-9.2-16.607-.656-1.3-1.27-2.582-1.871-3.881C-1.075,71.124-4.889,49.338,9.311,27.908,14.833,19.573,23.9,13.081,34.773,8.487a89.714,89.714,0,0,1,9.705-3.471c1.654-.519,3.32-.97,5.028-1.379q3.221-.82,6.547-1.436c1.7-.327,3.389-.614,5.1-.861q1.066-.141,2.132-.287A129.135,129.135,0,0,1,78.523.015C79.191,0,79.861,0,80.518,0c3.075.015,6.122.137,9.128.384.806.055,1.613.123,2.419.217,15.348,1.491,29.425,5.891,38.992,13.19a37.519,37.519,0,0,1,5.59,5.193c.3.342.589.683.861,1.037.1.109.179.219.273.329a36.621,36.621,0,0,1,4.758,7.681c6.082,13.243,2.527,27.852-5.947,41.465",
    transform: "translate(787.158 1718.548) rotate(-135)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(737.104 1577.527)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M44.622,77.291h0L38.678,66.98,22.149,38.357,19.6,33.964l-4.347-7.537L0,0H89.268l-.324.555-.185.3-2.081,3.63-7.54,13.04-.971,1.665L50.588,66.98,44.623,77.291ZM1.988,1.156,15.257,24.138l5.667,9.826,2.543,4.393L40,66.98l4.624,8,4.624-8L77.129,18.7l.946-1.665,4.349-7.514.393-.67L85.823,3.63l1.434-2.474Z",
    transform: "translate(13.425 12.295)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,2.406H26.843V1.25H0Z",
    transform: "translate(31.861 37.908)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,2.406H26.843V1.25H0Z",
    transform: "translate(31.861 46.666)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,2.406H26.843V1.25H0Z",
    transform: "translate(31.861 51.045)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,2.406H26.843V1.25H0Z",
    transform: "translate(31.861 55.424)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,2.406H26.843V1.25H0Z",
    transform: "translate(31.861 59.803)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,2.406H26.843V1.25H0Z",
    transform: "translate(31.861 64.182)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M26.788,26.79a15.693,15.693,0,1,1,0-22.193,15.7,15.7,0,0,1,0,22.193",
    transform: "translate(81.422 24.932)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M16.415,19.534H3.121A3.13,3.13,0,0,1,0,16.413V3.121A3.132,3.132,0,0,1,3.121,0H16.415a3.132,3.132,0,0,1,3.121,3.121V16.413a3.13,3.13,0,0,1-3.121,3.121",
    transform: "translate(7.644 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M16.415,19.534H3.121A3.13,3.13,0,0,1,0,16.413V3.121A3.132,3.132,0,0,1,3.121,0H16.415a3.132,3.132,0,0,1,3.121,3.121V16.413a3.13,3.13,0,0,1-3.121,3.121",
    transform: "translate(0 5.496)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(717.338 1625.753)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M12.235,47.034H75.956a3.577,3.577,0,0,0,3.6-4.41L72.611,4.41A5.525,5.525,0,0,0,67.4,0H3.682A3.577,3.577,0,0,0,.073,4.41L7.024,42.625a5.527,5.527,0,0,0,5.21,4.41",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.6,0H0L3.2,17.6H20.824L17.6,0ZM4.1,16.528,1.29,1.074H16.724l2.814,15.455Z",
    transform: "translate(50.223 32.323) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M83.133,0a6.081,6.081,0,0,1-6.064,6.064h-71A6.084,6.084,0,0,1,0,0Z",
    transform: "translate(14.961 49.182)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMandate);
export default __webpack_public_path__ + "static/media/mandate.2c0373286ba77624055512413c37427b.svg";
export { ForwardRef as ReactComponent };